import { SlideComponentDrawing } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentDrawingCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentDrawing {
        return {
            id: id,
            type: 'drawing',
            pos: {
                x: 0,
                y: 0,
            },
            size: { width: 400, height: 300 },
            content: {
                image: '',
                imageURL: '',
                flip: 1,
            },
        };
    }
}
